import { type Components } from '@/types/schemas/agent-schema';
import type { SearchFormValues } from '@packages/webshop-search-widget';

type Passenger = SearchFormValues['passengers'][number];

type PassengerSpecification =
  Components.Schemas.TurnitOsdmTranslatorApiFeaturesOffersModelsSearchOffersRequestPassengerSpecification;

export const buildFindOffersPassengerSpecifications = (
  passengers: Array<Passenger>
): Array<PassengerSpecification> =>
  passengers.map(
    ({ age, externalReference, type, card, cardNumber, cards, prmNeeds }) => ({
      age,
      externalReference,
      type,
      prmNeeds,
      // Passengers can carry discount cards in two shapes: a single card as
      // `card`/`cardNumber` strings (from the search form UI), or a `cards` array
      // (from external formValues / profile cards).
      cards: card
        ? [
            {
              code: card,
              number: cardNumber,
              useConcessionVouchers: false,
            },
          ]
        : cards?.map(
            ({ code, number, type, issuer, useConcessionVouchers }) => ({
              code,
              number,
              type,
              issuer,
              useConcessionVouchers: useConcessionVouchers || false,
            })
          ),
    })
  );
